import { combineReducers } from "redux";
import logs from "./logs";
import consumers from "./consumers";
import configuration from "./configuration";
import nodes from "./nodes";
import partitions from "./partitions";
import producer from "./producers";
import global from "./globals";

export default combineReducers({
    global,
    logs,
    consumers,
    configuration,
    nodes,
    partitions,
    producer,
});
